module.exports = __webpack_public_path__ + "img/19.b247bf5a.png";